import PropTypes from 'prop-types';
import styled from 'styled-components';
import _noop from 'lodash/noop';

import { media } from '@mlb/react-patterns/style/helpers/media.ts';
import ButtonPattern from '@mlb/react-patterns/components/Button/button.tsx';
import { IconWrapper } from '@mlb/react-patterns/components/Icon/icon.style.tsx';

import COLORS from '@mlb/react-patterns/style/universal.color';
import FONTS from '@mlb/react-patterns/style/fonts';

const DeleteReelButton = styled(ButtonPattern).attrs(({ label, onClick }) => ({
    iconName: 'trash-can',
    iconSize: 22,
    iconColor: COLORS.mlbGrey4,
    label: label,
    size: 'md',
    styleName: 'default',
    shape: 'hollow-borderless',
    handlers: {
        onClick: onClick,
    },
    dataAttr: {
        'data-click-handler': true,
    },
}))`
    text-align: left;
    white-space: nowrap;
    font-family: ${FONTS.primaryFont};
    font-weight: 600;
    letter-spacing: 0.2px;
    span {
        vertical-align: middle;
        padding-top: 2px;
    }
    ${IconWrapper} {
        vertical-align: middle;
        stroke: none;
    }
`;

DeleteReelButton.propTypes = {
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
};

export default DeleteReelButton;
